<template>
  <div class="product-step" :class="{ passed, active, 'no-label' : !(label) }">
    <div class="step-label" @click.prevent="goToStep" v-if="label">
      <h4>{{ label }}</h4>
      <div class="arrow">
        <span class="fi-rr-angle-up" v-if="active && !passed"></span>
        <span class="fi-rr-angle-down closed" v-if="!active && !passed"></span>
        <span class="fi-rr-check checked" v-if="passed"></span>
      </div>
    </div>
    <div class="step-content" v-if="active">
      <slot/>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Step',
  props: {
    step: Number,
    active: Boolean,
    passed: Boolean,
    label: String
  },
  computed: {
    ...mapState({
      phone: state => state.phone.item,
      loading: state => state.phone.loading
    })
  },
  methods: {
    goToStep () {
      this.$emit('open', { number: this.step })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/tools/*';
@import '../../../scss/mixins/*';

.product-step{
  margin-bottom: 10px;

  &.no-label{
    .step-content{
      @include radius(10px, 'top');
    }
  }

  &.active{
    .step-label{
      border-bottom: 1px solid darken($white, 5%);
      @include radius(0px, 'bottom');
    }
  }

  &.passed{
    .step-label{
      cursor: pointer;

      h4{
        color: $greenValidate;
      }

      .arrow{
        color: $greenValidate;
        font-size: 20px;
      }
    }
  }

  .step-label {
    display: flex;
    align-items: center;
    min-height: 40px;
    position: relative;
    padding: 20px 50px 20px 20px;
    background-color: $white;
    border-bottom: 1px solid $white;
    @include radius(10px);

    h4 {
      font-size: px2rem(16px);
      font-weight: $fontSemiBold;
    }

    .arrow {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 0;
      right: 10px;
      height: 100%;
      text-align: center;
      font-size: 16px;
      font-weight: $fontBold;
      width: 40px;
      color: $primary;
    }
  }

  .step-content {
    background-color: $white;
    padding: 20px;
    overflow: hidden;
    position: relative;
    @include radius(10px, 'bottom');
  }
}
</style>
